// load sass
import "../sass/page.scss";

$(function(){

  $('a[href^="#"]').click(function() {
    var headerH = $('#header').height();
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top - 70;
    $('body').css({'height':'', 'overflow-y':''});
    $("html, body").animate({ scrollTop: position }, 1000, "swing");
    return false;
  });

});

$(document).ready(function () {
  var urlHash = location.hash;
  if (urlHash) {
    var headerH = $('#header').height();
    $('body,html').stop().scrollTop(0);
    setTimeout(function () {
      var target = $(urlHash);
      var position = target.offset().top;
      $('body,html').stop().animate({ scrollTop: position }, 1000);
    }, 100);
    var hashString = location.hash.substr(1); // remove '#'
    history.replaceState('', document.title, window.location.pathname);
  }
});


//----- 電話クリック無効化
$(function() {
  if (window.matchMedia( "(min-width: 1081px)" ).matches) {
    $('#header-menu-box .header-tel-btn').on('click', function(){
      return false;
    });
  }
});

//----- ページトップへボタン
$(function () {
  var btn   = $("#scroll-to-top");
  var pdf   = $(".side-contents");
  var pdfdl = $('#download-document');

  if (window.matchMedia( "(min-width: 768px)" ).matches) {
    
    $(window).on("scroll", function () {
      var windowS = $(window).scrollTop();
      if (windowS > 300) {
        btn.fadeIn();
        pdfdl.addClass('up');
      } else {
        btn.fadeOut();
        pdfdl.removeClass('up');
      }
    });
  }
  btn.click(function () {
    $("html, body").animate({ scrollTop: 0 }, "300");
  });

  let w     = $(window).width();

  if (w >= 768 && w <= 1670) {
    pdf.addClass('hidden');
    $(window).on("scroll", function () {
      var windowS = $(window).scrollTop();
      if (windowS > 300) {
        pdf.removeClass('hidden');
      } else {
        pdf.addClass('hidden');
      }
    });
  }
});

//----- 文字を1文字ずつspanタグで囲む
$(function() {
  $('.js-span-wrap').children().andSelf().contents().each(function() {
    if (this.nodeType == 3) {
      $(this).replaceWith($(this).text().replace(/(\S)/g, '<span>$1</span>'));
    }
  });
});

//----- スクロールに応じて、要素の可視範囲とサイドメニューを連動させる
$(window).on('load', function (){
  if ($('.js-menu-interlocking-item').length) {

    if (window.matchMedia( "(min-width: 768px)" ).matches) {
      var winH       = $(window).height();
      var headerH    = $('#header').outerHeight();

      var items      = $('.js-menu-interlocking-item');
      $(window).on('load scroll',function(){
        var posScroll = $(window).scrollTop();
        $(items).each(function(i, val) {
          var objH   = $(val).height();
          var objTop = $(val).offset().top  - winH/4 - headerH;
          if(objTop <= posScroll && posScroll < objTop + objH) {
            let thisMenu = $(val).data("menu"); 
            if(thisMenu !== undefined) jQuery(".sidemenu ." + thisMenu).addClass("current");
          } else {
            let thisMenu = $(val).data("menu");
            if(thisMenu !== undefined) $(".sidemenu ." + thisMenu).removeClass("current");
          }
        });
      });

    }
  }
});

//-----要素の高さを揃える処理
function fn_set_item_height(_columns, _item, _target) {
  //一行あたりの要素数=列数を変数に格納
  var columns = _columns;
  //該当するli要素の数を取得
  var liLen = _item.length;
  //行の数を取得
  var lineLen = Math.ceil(liLen / columns);
  //各li要素の高さの配列
  var liHiArr = [];
  //行の高さの配列
  var lineHiArr = [];

  //liの高さを配列に格納後、それが行の中で一番高い値であれば行の高さとして格納していく繰り返し文
  for (i = 0; i <= liLen; i++) {
    liHiArr[i] = _target.eq(i).height();
    if (lineHiArr.length <= Math.floor(i / columns) 
        || lineHiArr[Math.floor(i / columns)] < liHiArr[i]) {
      lineHiArr[Math.floor(i / columns)] = liHiArr[i];
    }
  }
  
  //.eachでそれぞれのliの高さを変更
  _target.each(function(i){
    $(this).css('height', lineHiArr[Math.floor(i / columns)] + 'px');
  });

}
